/**
 * Public-shell header labels. Never surface internal import / machine
 * admin identifiers (e.g. "Import Admin cimport-…") on marketing pages.
 */
const INTERNAL_NAME_RE =
  /^(import\s+admin\b|cimport-|grokbot\b|machine\s+admin\b)/i;

export function publicDisplayName(
  name: string | null | undefined,
  opts?: { role?: string | null; email?: string | null },
): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed || INTERNAL_NAME_RE.test(trimmed) || /cimport-/i.test(trimmed)) {
    if (opts?.role === "admin") return "Account";
    const email = (opts?.email ?? "").trim();
    if (email.includes("@")) return email.split("@")[0] || "Account";
    return "Account";
  }
  return trimmed;
}
